import ActiveCustomerInfo from "./ActiveCustomerInfo";
import GlobalSearch from "./GlobalSearch";
import HelpMenu from "./HelpMenu";
import UserMenu from "./UserMenu";
import StopImpersonationButton from "../../../StopImpersonationButton";

const Header = () => (
  <header class="flex items-center bg-surface-extra-subtle py-1.5 pr-2.5">
    <ActiveCustomerInfo />
    <GlobalSearch />

    <div class="ml-auto flex items-center gap-2">
      <StopImpersonationButton />
      <HelpMenu triggerSize="large" showExitBeta />
      <UserMenu />
    </div>
  </header>
);

export default Header;
